import React, { useCallback } from 'react';

import {
  DateInput,
  IDateInputProps,
} from '@rbilabs/components-library/build/components/date-input';
import { FieldProps } from 'formik';
import { useIntl } from 'react-intl';

import { OptionalProps } from '@rbi-ctg/frontend';

export const FormikBirthdayInput = ({
  field,
  form,
  ...props
}: FieldProps &
  OptionalProps<
    IDateInputProps,
    | 'label'
    | 'labelYear'
    | 'labelYearFormat'
    | 'labelMonth'
    | 'labelMonthFormat'
    | 'labelDay'
    | 'labelDayFormat'
  >) => {
  const { formatMessage } = useIntl();
  const handleInputChange = useCallback(
    e => {
      form.setFieldValue(e.target.name, e.target.value);
    },
    [form]
  );

  const errors = form.touched.dob ? (form.errors?.dob as string) : undefined;

  return (
    <DateInput
      data-testid="dateOfBirth"
      autoComplete="bday"
      {...field}
      label={formatMessage({ id: 'dateOfBirth' })}
      labelYear={formatMessage({ id: 'year' })}
      labelYearFormat={formatMessage({ id: 'yearPlaceholder' })}
      labelMonth={formatMessage({ id: 'month' })}
      labelMonthFormat={formatMessage({ id: 'monthPlaceholder' })}
      labelDay={formatMessage({ id: 'day' })}
      labelDayFormat={formatMessage({ id: 'dayPlaceholder' })}
      name="dob"
      {...props}
      errorMessage={errors}
      onBlur={form.handleBlur}
      onChange={handleInputChange}
      month={form.values.dob?.month}
      day={form.values.dob?.day}
      year={form.values.dob?.year}
    />
  );
};
